// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/line.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background: #E9DDEC;
}

.top-header::after {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: top;
    height: 10px;
    width: 100%;
    background-size: contain;
}

@media (min-width: 768px) {
    .top-header::after {
        height: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./theme/css/themes/gymbaroo.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,mDAAwC;IACxC,wBAAwB;IACxB,YAAY;IACZ,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":["body {\r\n    background: #E9DDEC;\r\n}\r\n\r\n.top-header::after {\r\n    background: url('../../images/line.png');\r\n    background-position: top;\r\n    height: 10px;\r\n    width: 100%;\r\n    background-size: contain;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .top-header::after {\r\n        height: 15px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
